import { render, staticRenderFns } from "./CreateLayoverHeader.vue?vue&type=template&id=1455a722"
import script from "./CreateLayoverHeader.vue?vue&type=script&lang=js"
export * from "./CreateLayoverHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports